import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useAuth } from 'hooks/useAuth'
import { usePageTracking } from 'hooks/use-page-tracking'
import { useStore } from 'hooks/useStore'
import { UpdateTermsOfServiceAndPrivacyModal, DeleteAccountBlock } from 'containers/common'
import { ComponentGuard } from 'guards'
import { ImpersonatedBadge } from 'components/molecules/impersonated-badge'

export function OfferLayout() {
	usePageTracking()
	const { token, authInfo } = useAuth()
	const { blur, loadingLogout, openDeleteAccount, setOpenDeleteAccount, refetchUser } = useStore()

	useEffect(() => {
		if (token && authInfo && !loadingLogout) {
			refetchUser()
		}
	}, [token, JSON.stringify(authInfo), loadingLogout])

	return (
		<div className={clsx({ blur })}>
			<Helmet
				bodyAttributes={{
					class: clsx('bg-theme-surface'),
				}}
			/>
			<ImpersonatedBadge />
			<div className="min-h-screen mx-auto">
				<main className="pb-20">
					{/* Start main area*/}
					<Outlet />
					{/* End main area */}
				</main>
			</div>
			<UpdateTermsOfServiceAndPrivacyModal />
			<ComponentGuard includeRoutes={['/profile/information', '/profile/personal']}>
				<DeleteAccountBlock openDelete={openDeleteAccount} setOpenDelete={setOpenDeleteAccount} />
			</ComponentGuard>
			{loadingLogout && (
				<div className="flex justify-center items-center py-4 size-full fixed top-0 left-0 bg-primary-surface/[0.4] backdrop-blur-lg bg-opacity-90 z-[9999]">
					<FontAwesomeIcon icon={['fas', 'spinner']} size="2x" spin className="text-white" />
				</div>
			)}
		</div>
	)
}
